import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountLedgerComponent } from './account-ledger/account-ledger.component';
import { CompanyInformationComponent } from './company-information/company-information.component';
import { DelieveryAddressComponent } from './delievery-address/delievery-address.component';
import { EnduserAddressComponent } from './enduser-address/enduser-address.component';
import { UsersComponent } from './users/users.component';
import { MyAccountRoutingModule } from './my-account.routing.module';
import { MyAccountComponent } from './my-account.component';
import { AdsModule } from '../adcomponents/ad.module';
import { EndUserDisplayComponent } from './enduser-display/enduser-display.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgProgressModule } from 'ngx-progressbar';
import { PaymentSetupComponent } from './payment-setup/payment-setup.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../shared/shared.module';
import { MatInputModule } from '@angular/material/input';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { ApitokensComponent } from './apitokens/apitokens.component';
import { ApicredentialsV2Component } from './apicredentialsV2/apicredentialsV2.component';
import { ManageUserComponent } from './users/manage-user/edit-user/manage-user.component';
import { AddUserComponent } from './users/add-user/add-user.component';
import { EditEndUserAddressBookComponent } from './enduser-address/edit-end-user-address-book/edit-end-user-address-book.component';
import { PortalBrandingComponent } from './portal-branding/portal-branding.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { MakePaymentComponent } from './make-payment/make-payment.component';
import { EditDeliveryAddressComponent } from './delievery-address/edit-delivery-address/edit-delivery-address.component';
import { AddDeliveryAddressComponent } from './delievery-address/add-delivery-address/add-delivery-address.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { ChildHeaderModule } from '../child-header/child-header.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import {MatDividerModule} from '@angular/material/divider';
import { ModalPopupModule } from '../shared/modal-popup/modal-popup.module';
import { ReturnSearchComponent } from '../admin/returns/return-search/return-search.component';
import {ReturnsDetailsComponent} from '../admin/returns/return-search/return-details/return-details.component';
import { BreadcrumbModule } from '../breadcrumb/breadcumb.module';
import { PasswordModule } from '../shared/password/password.module';
import { MatTooltipModule } from '@angular/material/tooltip';

import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatExpansionModule} from '@angular/material/expansion';
import { DevOpsAuthGuard } from '../admin/admin.authguard';

@NgModule({
  imports: [
    MatTooltipModule,
    CommonModule,
    MyAccountRoutingModule,
    AdsModule,
    FormsModule,
    ReactiveFormsModule,
    NgProgressModule,
    SharedModule,
    MatInputModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSelectModule,
    MatDividerModule,
    MatTableModule,
    MatFormFieldModule,
    MatSlideToggleModule,
    MatIconModule,
    MatAutocompleteModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatExpansionModule,
    // ColorPickerModule,
    ColorPickerModule,
    NgbModule,
    NgSelectModule,
    PasswordModule,
    ChildHeaderModule,
    ModalPopupModule,
    BreadcrumbModule    
  ],
  declarations: [
    AccountLedgerComponent,
    CompanyInformationComponent,
    DelieveryAddressComponent,
    EnduserAddressComponent,
    UsersComponent,
    MyAccountComponent,
    EndUserDisplayComponent,
    PaymentSetupComponent,
    ApitokensComponent,
    ApicredentialsV2Component,
    ManageUserComponent,
    AddUserComponent,
    EditEndUserAddressBookComponent,
    PortalBrandingComponent,
    MakePaymentComponent,
    EditDeliveryAddressComponent,
    AddDeliveryAddressComponent,
    ReturnSearchComponent,
    ReturnsDetailsComponent
  ],
  providers: [
    DevOpsAuthGuard
  ]
})
export class MyAccountModule { }
